// Поддержка обоих доменов - старого и нового
const SUPABASE_STORAGE_PREFIXES = [
  "https://dbng745h-fdf.fermerchel74.ru/storage/v1/object/public/",
  "https://supabase.fermerchel74.ru/storage/v1/object/public/"
];
const IMAGE_PROXY_URL = "https://img.fermerchel74.ru";

// Прокси включен - изображения проксируются через edge function
const PROXY_ENABLED = true;

/**
 * Transforms a direct Supabase storage URL into a proxied URL
 * This hides the actual Supabase infrastructure from end users
 */
export function getProxiedImageUrl(url: string | null | undefined): string | null {
  if (!url || url.trim() === "") {
    return null;
  }

  // Если прокси отключен, возвращаем оригинальный URL
  if (!PROXY_ENABLED) {
    return url;
  }

  // Find matching prefix (supports both old and new domains)
  const matchingPrefix = SUPABASE_STORAGE_PREFIXES.find(prefix => url.startsWith(prefix));
  
  if (!matchingPrefix) {
    // Return as-is if it's not a Supabase URL (external images, etc.)
    return url;
  }

  // Extract the path after the public/ prefix
  const path = url.replace(matchingPrefix, "");
  
  // Encode the path in base64 (URL-safe)
  const encodedPath = btoa(path);
  
  // Construct the proxy URL
  return `${IMAGE_PROXY_URL}?p=${encodeURIComponent(encodedPath)}`;
}

/**
 * Hook-friendly version that can be used in components
 */
export function useProxiedImage(url: string | null | undefined): string | null {
  return getProxiedImageUrl(url);
}
